const EnPrizes = () => {
  return (
    <>
      <section>
        <h3>Grand Prize - First (1st) Overall Ranking</h3>
        <p>
          There will be one (1) Grand Prize Winner (“Grand Prize Winner”)
          awarded to the Entrant with the most accumulated points for the
          duration of the Contest.
        </p>
        <p>The “Grand Prize” consists of:</p>
        <ul>
          <li>
            <p>
              Transportation from the Winners residence to Paris, France, either
              via two (2) Economy class round trip airline tickets from the
              closest international airport to the Winners residence to an
              airport in Paris, France, or via round trip train tickets from the
              closest station to the Winners residence to Paris, France (as
              determined and communicated by the Sponsor in its sole
              discretion).
            </p>
            <ul>
              <li>
                <p>
                  Specific seat selection is the sole discretion of the Sponsor
                </p>
              </li>
              <li>
                <p>
                  Exact transportation method, dates and times will be
                  determined by the Sponsor in their sole discretion
                </p>
              </li>
            </ul>
          </li>
          <li>
            <p>
              One (1) hotel room for two (2) in Paris for a total of three (3)
              nights at a 3-4 star hotel
            </p>
            <ul>
              <li>
                <p>
                  Hotels, rooms, and dates to be chosen by the Sponsor in their
                  sole discretion
                </p>
              </li>
            </ul>
          </li>
          <li>
            <p>
              Two (2) game tickets to one (1) NBA Paris Game during the 2027-28
              NBA season (the “Game”)
            </p>
            <ul>
              <li>
                <p>Exact Game date is the sole discretion of the Sponsor</p>
              </li>
            </ul>
          </li>
          <li>
            <p>
              A First Place trophy, delivered in person or via courier to the
              winner's address, decided at the Sponsor's sole discretion.
            </p>
          </li>
        </ul>
        <p>
          Approximate total cumulative retail value of the Grand Prize is
          €2,500.00.
        </p>
        <p>
          Winner can nominate one (1) friend or family member to attend with
          them (the “Guest”).
        </p>
        <p>
          Grand Prize winners from any previous season are not eligible to claim
          the Grand Prize. In such circumstances, the Grand Prize will be
          awarded to the next eligible Entrant, and the ineligible Grand Prize
          winner will claim the Second (2nd) place prize instead.
        </p>
      </section>
      <section>
        <p>
          Four (4) Additional Secondary Season Long Prizes - Second (2nd)
          through fifth (5th) Overall Ranking These four (4) additional
          secondary prizes will be awarded to the Entrants with the second
          (2nd), third (3rd), fourth (4th), and fifth (5th) most cumulative
          points for the duration of the Contest (each a “Secondary Prize
          Winner”).
        </p>
        <ul>
          <li>
            <p>
              Second (2nd) place prize: NBA Store gift card x €200.00 at{" "}
              <a
                href="https://nbastore.eu/"
                target="_blank"
                rel="noopener noreferrer"
              >
                nbastore.eu
              </a>
            </p>
          </li>
          <li>
            <p>
              Third (3rd) place prize: NBA Store gift card x €200.00 at{" "}
              <a
                href="https://www.nbastore.eu"
                target="_blank"
                rel="noopener noreferrer"
              >
                nbastore.eu
              </a>
            </p>
          </li>
          <li>
            <p>
              Fourth (4th) place prize: NBA Store gift card x €200.00 at{" "}
              <a
                href="https://www.nbastore.eu"
                target="_blank"
                rel="noopener noreferrer"
              >
                nbastore.eu
              </a>
            </p>
          </li>
          <li>
            <p>
              Fifth (5th) place prize: NBA Store gift card x €200.00 at{" "}
              <a
                href="https://www.nbastore.eu"
                target="_blank"
                rel="noopener noreferrer"
              >
                nbastore.eu
              </a>
            </p>
          </li>
        </ul>
      </section>
      <section>
        <h3>Weekly:</h3>
        <p>
          Twenty-five (25) additional prizes will be awarded to the Entrant with
          the most points in a given week (each a “Weekly Prize Winner”). One
          (1) Weekly Prize to be awarded per week x 25 total weeks Contest
          duration.
        </p>
        <p>
          The Weekly Prize will consist of a Digital Copy of NBA 2K27 and an NBA
          Store gift card x €100.00 at{" "}
          <a
            href="https://www.nbastore.eu"
            target="_blank"
            rel="noopener noreferrer"
          >
            nbastore.eu
          </a>{" "}
          (to be determined by the Sponsor in its sole discretion). Approximate
          total cumulative retail value of a Weekly Prize is €150.00.
        </p>
        <p>
          To be eligible to win the Weekly Prizes, users must have entered the
          game either before the start of the NBA season or a minimum of 14 days
          prior to the start of the relevant gameweek period.
        </p>
        <p>
          A full list of gameweeks is available in the{" "}
          <a
            href="https://nbafantasy.nba.com/help/rules"
            target="_blank"
            rel="noopener noreferrer"
          >
            how to play
          </a>{" "}
          section. Gameweeks are subject to change at the Sponsor's sole
          discretion.
        </p>
      </section>
      <section>
        <h3>Eligibility:</h3>
        <p>
          The Promotion is limited to residents of Austria, Belgium, Czechia,
          Denmark, Finland, France, Germany, Greece, Hungary, Ireland, The
          Netherlands, Norway, Portugal, Serbia, Spain, Switzerland, and the
          United Kingdom (together, the “Territory”), who are eighteen (18)
          years of age or older as at the date of contest entry submission
          (each, an “Entrant”). For the avoidance of doubt, residents outside
          the above mentioned jurisdictions and/or Entrants who have not reached
          the age of eighteen (18) years of age as at the date of contest entry
          submission, are not eligible to participate in this Promotion. The
          Sponsor, as defined below, reserves the right to confirm the
          eligibility of any Entrant, including verifying their age.
        </p>
      </section>
    </>
  );
};

export { EnPrizes };
